import { useContext } from 'react';

import WaitingLineContext, { IWaitingLineContext } from './WaitingLineContext';

export default function useWaitingLine() {
  return useContext<IWaitingLineContext>(WaitingLineContext);
}
